import { useState } from 'react';
import {
    Container,
    Paper,
    TextField,
    Button,
    Typography,
    Box,
    IconButton,
    InputAdornment,
    Grid,
    Fade,
    useMediaQuery,
} from '@mui/material';
import {
    Visibility,
    VisibilityOff,
    Email,
    Lock,
} from '@mui/icons-material';
import SimpleBackdrop from '../../components/Loading/Simplebackdrop';
import { AlertInfo } from '../../components/Alerts/Alert';
import { api } from '../../services/api';
import { useNavigate } from 'react-router-dom';

function Login() {
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState("");
    const [senha, setSenha] = useState("");
    const navigate = useNavigate();

    const isMobile = useMediaQuery('(max-width:600px)');

    const handleSubmit = async () => {
        setLoading(true);
        try {
            const response = await api.post(`/login`, { email, senha });
            if (response.data.id_usuario_master) {
                sessionStorage.setItem("infoLogin", JSON.stringify(response.data));
                return navigate("/");
            } else if (response.data.error) {
                AlertInfo({ icon: 'error', title: response.data.msg });
            }
        } catch (error) {
            console.log(error);
            AlertInfo({ icon: 'error', title: 'Falha na conexão' });
        }
        setLoading(false);
    };

    return (
        <Box
            sx={{
                minHeight: '100vh',
                background: '#ffffff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 2,
                position: 'relative',
            }}
        >
            <SimpleBackdrop open={loading} />

            <Container maxWidth="sm">
                <Fade in timeout={800}>
                    <Paper
                        elevation={24}
                        sx={{
                            padding: isMobile ? 3 : 5,
                            backgroundColor: '#ffffff',
                            border: '1px solid rgba(0, 0, 0, 0.1)',
                            borderRadius: 3,
                            position: 'relative',
                            overflow: 'hidden',
                        }}
                    >
                        <Box textAlign="center" mb={4}>
                            <Typography
                                variant="h4"
                                component="h1"
                                gutterBottom
                            >
                                Bem-vindo
                            </Typography>
                            <Typography variant="body1" color="text.secondary">
                                Faça login em sua conta para continuar
                            </Typography>
                        </Box>

                        <Grid container spacing={2}>
                            <Grid size={12}>
                                <TextField
                                    fullWidth
                                    id="email"
                                    label="Email"
                                    type="email"
                                    size='small'
                                    value={email}
                                    onChange={e => setEmail(e.target.value)}
                                    autoComplete="email"
                                    autoFocus
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Email color="action" />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>

                            <Grid size={12}>
                                <TextField
                                    fullWidth
                                    id="password"
                                    label="Senha"
                                    size='small'
                                    type={showPassword ? 'text' : 'password'}
                                    value={senha}
                                    onChange={e => setSenha(e.target.value)}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Lock color="action" />
                                            </InputAdornment>
                                        ),
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={() => setShowPassword(!showPassword)}
                                                    edge="end"
                                                >
                                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Grid>

                            <Grid size={12}>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    onClick={handleSubmit}
                                >
                                    Entrar
                                </Button>
                            </Grid>
                        </Grid>
                    </Paper>
                </Fade>
            </Container>
        </Box>
    );
}

export default Login;